import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      initConfig: state => state.initConfig
    })
  },
  data() {
    return {
      fontVersion: '',
      backendVersion: '',
      applicationName: ''
    };
  },
  mounted() {
    let fontEndVersionStr = localStorage.getItem('networkOperationCenter');
    if (fontEndVersionStr && fontEndVersionStr.includes('_')) {
      fontEndVersionStr = JSON.parse(fontEndVersionStr);
      fontEndVersionStr = fontEndVersionStr.substring(0, fontEndVersionStr.indexOf('_'));
    }
    this.fontVersion = fontEndVersionStr;
  },
  methods: {
    topHeaderCallback(info) {
      const {
        type
      } = info;
      if (type === 'signOut' || type === 'sessionExpired') {
        this.logout();
      }
    },
    logout() {
      const url = location.protocol + '//' + `${this.initConfig.urlInfo.userAuth}/main/logout`;
      this.axios.post(url).then(res => {
        if (res.data.errorCode === '0x0') {
          const userServerUrl = this.initConfig.urlInfo.userservice;
          const serverName = this.initConfig.serverName || 'Network Operation Center';
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}&serviceName=${serverName}`;
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
};